import amplitude from "amplitude-js";
import { customEvent } from "gtag";

export const logEvent = (eventName: string, data: any) => {
    customEvent(eventName, {...data, event_category: 'engagement' });
    amplitude.getInstance().logEvent(eventName, data);
};